import React, { useState } from "react";
import {
  Menu as MenuIcon,
  ArrowDropDownOutlined,
} from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { APIURL } from "../globals";
import { useAuth } from "../contexts/AuthContext";
import {
  AppBar,
  Box,
  Typography,
  IconButton,
  Toolbar,
  Menu,
  MenuItem,
  Button,
} from "@mui/material";

const COMPLIANCE_TEXT =
  'The principle AML/CFT legislation applicable is the Federal Decree-Law No. (20) of 2018 On Anti-Money Laundering and Combating the Financing of Terrorism and Financing of Illegal Organisations';

const Navbar = ({ user, isSidebarOpen, setIsSidebarOpen }) => {
  const navigate = useNavigate();
  const { refetch } = useAuth();

  const [anchorEl, setAnchorEl] = useState(null);
  const isOpen = Boolean(anchorEl);
  const handleClick = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const handleLogout = async () => {
    try {
      await fetch(APIURL + "/general/logout", {
        method: "GET",
        withCredentials: true,
        credentials: "include",
        headers: { "Content-Type": "application/json" },
      });
      await refetch();
      navigate("/");
    } catch (error) {
      console.error("Logout error:", error);
      navigate("/");
    }
  };

  return (
    <AppBar
      position="sticky"
      sx={{
        background: "#fff",
        borderBottom: "1px solid #E2E8F0",
        boxShadow: "0 1px 4px rgba(15,23,42,.04)",
        zIndex: 1200,
      }}
    >
      <Toolbar
        sx={{
          minHeight: "60px !important",
          px: { xs: 2, md: 3 },
          gap: 1,
        }}
      >
        {/* Left: hamburger */}
        <IconButton
          onClick={() => setIsSidebarOpen((v) => !v)}
          sx={{ color: "#0F172A", flexShrink: 0 }}
        >
          <MenuIcon />
        </IconButton>

        {/* Center: scrolling ticker */}
        <Box
          sx={{
            flex: 1,
            overflow: "hidden",
            mx: 1,
            "@keyframes marqueeScroll": {
              from: { transform: "translateX(100%)" },
              to: { transform: "translateX(-100%)" },
            },
          }}
        >
          <Typography
            sx={{
              fontSize: 11,
              color: "#94A3B8",
              fontStyle: "italic",
              fontFamily: "IBM Plex Sans, sans-serif",
              whiteSpace: "nowrap",
              animation: "marqueeScroll 30s linear infinite",
              display: "inline-block",
            }}
          >
            {COMPLIANCE_TEXT}
          </Typography>
        </Box>

        {/* Right: user button + dropdown */}
        <Box sx={{ flexShrink: 0 }}>
          <Button
            onClick={handleClick}
            endIcon={<ArrowDropDownOutlined sx={{ color: "#64748B" }} />}
            sx={{
              textTransform: "none",
              display: "flex",
              alignItems: "center",
              gap: 0.5,
              p: "4px 8px",
              borderRadius: "8px",
              "&:hover": { background: "#F8FAFC" },
            }}
          >
            <Box textAlign="left">
              <Typography
                sx={{
                  fontWeight: 600,
                  fontSize: 14,
                  color: "#0F172A",
                  fontFamily: "IBM Plex Sans, sans-serif",
                  lineHeight: 1.2,
                }}
              >
                {user?.name || ""}
              </Typography>
              <Typography
                sx={{
                  fontSize: 11,
                  color: "#64748B",
                  fontFamily: "IBM Plex Sans, sans-serif",
                  lineHeight: 1.2,
                }}
              >
                {user?.email || ""}
              </Typography>
            </Box>
          </Button>
          <Menu
            anchorEl={anchorEl}
            open={isOpen}
            onClose={handleClose}
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            transformOrigin={{ vertical: "top", horizontal: "right" }}
            PaperProps={{
              sx: {
                mt: 0.5,
                border: "1px solid #E2E8F0",
                boxShadow: "0 4px 16px rgba(15,23,42,.08)",
                borderRadius: "10px",
                minWidth: 140,
              },
            }}
          >
            <MenuItem
              onClick={handleLogout}
              sx={{
                fontSize: 13,
                fontFamily: "IBM Plex Sans, sans-serif",
                color: "#0F172A",
                "&:hover": { background: "#F8FAFC" },
              }}
            >
              Log Out
            </MenuItem>
          </Menu>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Navbar;
